/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { injectIntl } from 'react-intl';
import { Modal, Button } from 'react-bootstrap';
import IntlMsg from 'lorautils/intl/IntlMsg';
import PropTypes from 'prop-types';
import callAPI from '@/api/callAPI';
import styles from './styles.scss';

const propTypes = {
  intl: PropTypes.object.isRequired,
  showModal: PropTypes.bool.isRequired,
  checkedNodes: PropTypes.array.isRequired,
  onCancel: PropTypes.func.isRequired,
};

class ResetNodes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: props.showModal,
      checkedNodes: props.checkedNodes,
    };
    this.intlMsg = new IntlMsg(props.intl, 'network.tdm.node.reset');
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentWillReceiveProps({ showModal, checkedNodes }) {
    if (showModal !== this.props.showModal) {
      this.setState({ showModal });
    }
    if (!_.isEqual(checkedNodes, this.props.checkedNodes)) {
      this.setState({ checkedNodes });
    }
  }

  onSubmit() {
    this.setState({ submitStatus: 'pending' });

    const { checkedNodes } = this.state;
    const copyNodes = _.cloneDeep(checkedNodes);
    const reset = () => {
      const node = copyNodes.pop();
      if (node) {
        callAPI({
          endpoint: `/tdmng/nodes/${node}/ctrl/kick`,
          method: 'POST',
        }).then(() => {
          reset();
        }).catch(() => {});
      } else {
        this.setState({ submitStatus: 'success' });

        _.delay(() => {
          this.props.onCancel();
        }, 250);
      }
    };
    reset();
  }

  render() {
    const {
      showModal,
      submitStatus,
    } = this.state;

    return (
      <Modal
        bsClass="aisz-modal-warning"
        show={showModal}
        backdrop="static"
        onHide={this.props.onCancel}
      >
        <Modal.Header closeButton>
          {this.intlMsg.msg('title')}
        </Modal.Header>
        <Modal.Body>
          <div className="text-center">
            {this.intlMsg.msg('warn')}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            bsStyle="aisz-default"
            className={styles.white}
            onClick={this.props.onCancel}
          >
            {this.intlMsg.msg('cancel')}
          </Button>
          <Button
            bsStyle="aisz-warning"
            onClick={this.onSubmit}
            disabled={submitStatus === 'pending'}
          >
            {submitStatus === 'pending' && <i className="fa fa-spin fa-spinner m-r-s" />}
            {this.intlMsg.msg('confirm')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

ResetNodes.propTypes = propTypes;

export default injectIntl(ResetNodes);




// WEBPACK FOOTER //
// ./src/containers/Network/coms/TDMView/Node/ResetNodes.jsx